import { Application, Controller } from "stimulus"

export default class ManageFiltersController extends Controller {

  static targets = ["checkContainer", "filterSection"]
  static values = { selectableFilters: {type: String, default: ""}, 
                    experiment: {type: Boolean, default: false}, 
                  }
  selectableFilters;
  lastFilterType = "";
  lastFilterUnchecked = false;

  connect() {
    window.manage_filters = this;
    if(this.experimentValue) {
      this.manageFilters();
    }
  }

  manageFilters() {
    this.selectableFilters = JSON.parse(this.selectableFiltersValue.replace(/&quot;/g, '\"'));
    this.checkContainerTargets.forEach(checkContainer => {
      const filterKey = this.filterKey(checkContainer);
      if(filterKey != this.lastFilterType || this.lastFilterUnchecked) {
        const filterValue = checkContainer.dataset.filterValue;
        this.enableDisableFilter(checkContainer, filterKey, filterValue);
      }
    });
  }

  filterKey(checkContainer) {
    var filterKey = '';
    try {
      filterKey = JSON.parse(checkContainer.dataset.filterKey);
    } catch (e) {
      filterKey = checkContainer.dataset.filterKey;
    }
    return filterKey;
  }

  enableDisableFilter(checkContainer, filterKey, filterValue) {
    if (this.selectableFilter(filterKey, filterValue)) {
      checkContainer.classList.remove('disabled')
    }else{
      checkContainer.classList.add('disabled')
    }
  }

  selectableFilter(filterKey, filterValue) {
    let selectable = false;
    [filterKey].flat().forEach(key => {
      if((this.selectableFilters.hasOwnProperty(key) && filterValue == '') || this.selectableFilters[key]?.includes(filterValue)) {
        selectable = true 
      }
    });
    return selectable;
  }

  filter(e) {
    const form = e.target.closest("form")
    this.setLastFilter(e.target);
    this.updateURL(form);
    this.submitForm(form);
  }

  setLastFilter(lastParam) {
    if(lastParam.type == "checkbox") {
      this.lastFilterUnchecked = !lastParam.checked;
      this.lastFilterType = lastParam.name.replace('[]','')
      this.filterSectionTarget.value = this.lastFilterType;
    }
  }

  updateURL(form) {
    const formData = new FormData(form);
    const formParamsUrl = new URLSearchParams(formData).toString();
    if (formParamsUrl != null) {
      const formUrl = `${location.origin}${location.pathname}?${formParamsUrl}`;
      Turbo.navigator.history.push(new URL(formUrl))
      gtag("event", "page_view", { page_location: formUrl })
    }
  }

  submitForm(form) {
    if(form.requestSubmit) {
      form.requestSubmit();
    }else {
      form.dispatchEvent(new CustomEvent('submit', {bubbles: true}))
    }
  }

}

const application = Application.start()
application.register("manage-filters", ManageFiltersController)